export { c as createFutureButtonWithTheme, e as extractCSSOption, a as useThemeCSS, u as useThemeCSSPart } from './index-ada15b77.js';
export { ThemeProvider } from './ThemeProvider.js';
export { Layout } from './Layout.js';
export { Section } from './Section.js';
export { Container } from './Container.js';
export { VisuallyHidden } from './VisuallyHidden.js';
export { B as Button } from './index-66466a7c.js';
export { ColorsAutokit } from './ColorsAutokit.js';
export { TypographyAutokit } from './TypographyAutokit.js';
export { IconsAutokit } from './IconsAutokit.js';
export { LayoutAutokit } from './LayoutAutokit.js';
export { ShadowsAutokit } from './ShadowsAutokit.js';
export { ButtonAutokit } from './ButtonAutokit.js';
export { baseTheme } from './baseTheme.js';
export { createTheme } from './createTheme.js';
export { useTheme } from './useTheme.js';
export { s as scale } from './scale-15569e54.js';
export { typography } from './typography.js';
import { _ as _slicedToArray, a as _objectSpread2, b as _defineProperty } from './_rollupPluginBabelHelpers-bd852068.js';
import './emotion-react.esm-95faa810.js';
import './emotion-element-6bdfffb2.esm-f2337626.js';
import 'react';
import './style-inject.es-1f59c1d0.js';
import './useCSSProperty-285fe927.js';
import './typography-b7cd0eb9.js';
import './copyToClipboard-398503c3.js';
import 'react-dom';
import './cjs-9df6abb2.js';

/**
 * Creates a statically typed object representing media queries
 * given a map of breakpoints from tokens
 * @example
 * // scripts/gds.ts
 * import tokens from '../../../public/tokens.json';
 * const { breakpoints } = tokens.layout;
 * const MEDIA_QUERIES = createMediaQueries(breakpoints);
 * // ...
 * export {MEDIA_QUERIES };
 * @example
 * // components/Example/themes/basic/index.ts
 * import { MEDIA_QUERIES } from '@scripts/gds';
 * export const basicTheme: ExampleComponentTheme = {
 *  subComponent: {
 *    // statically typed
 *    [MEDIA_QUERIES.sm]: {
 *        width: '100%',
 *    }
 *  }
 * }
 * @param breakpoints breakpoints from tokens
 */
var createMediaQueries = function createMediaQueries(breakpoints) {
  var queries = Object.entries(breakpoints).reduce(function (acc, _ref) {
    var _objectSpread2$1;
    var _ref2 = _slicedToArray(_ref, 2),
      name = _ref2[0],
      value = _ref2[1];
    return _objectSpread2(_objectSpread2({}, acc), {}, (_objectSpread2$1 = {}, _defineProperty(_objectSpread2$1, name, "@media (max-width: ".concat(value - 1, "px)")), _defineProperty(_objectSpread2$1, "".concat(name, "Min"), "@media (min-width: ".concat(value, "px)")), _objectSpread2$1));
  }, {});
  return queries;
};

export { createMediaQueries };
